import { axiosServices } from "./config.services";

export async function GetAllTypes() {
  return await axiosServices.get("/tipos/listpop");
}
